import {
  adminActions,
  pendingCancellationDetails,
  successSelector,
} from '@pharmaplan/common';

import { IDynamicTableObject } from '../../../components/DynamicTable/types';
import { getDayMonthDateYear } from '../../../components/Reports/helpers';
import { DynamicTableCell, nameLabels } from '../../../helpers/Constants';
import { useAppSelector } from '../../useAppSelector';
import strings from '../../../localization';

const { text } = DynamicTableCell;

const usePendingCancellationDetails = () => {
  const success = useAppSelector((state) =>
    successSelector([adminActions.getPendingCancellationDetails], state));

  const cancellationDetails = useAppSelector(pendingCancellationDetails);

  const {
    requestReason,
    requestCode,
    requestType,
    selectedDate,
    cancellationReason,
    pharmacistName,
    pharmacyName,
    workshiftCode,
    cancellationDate,
    approvedByName,
    availabilityCode,
    cancellationRejectionDate,
    rejectionReason,
    confirmationCode,
    rejectedByName,
    status,
    bookings,
  } = cancellationDetails ?? {};

  const parsedDate = getDayMonthDateYear(selectedDate);
  const parsedRejectedDate = getDayMonthDateYear(
    cancellationRejectionDate ?? '',
  );
  const parsedCancellationDate = getDayMonthDateYear(cancellationDate);

  const headers = [
    {
      key: '0',
      label: strings.bookingDate,
    },
    {
      key: '1',
      label: strings.shiftCode,
    },

    {
      key: '2',
      label: strings.availabilityCode,
    },
  ];

  const rows = () =>
    (bookings ?? [])?.map((item) => {
      const {
        availabilityCode: aCode,
        bookingId,
        shiftCode,
        selectedDate: sDate,
      } = item ?? {};
      const date = getDayMonthDateYear(sDate);
      return {
        key: bookingId,
        data: [
          {
            key: 0,
            value: date,
            type: text,
          },
          {
            key: 1,
            value: shiftCode,
            type: text,
          },
          {
            key: 2,
            value: aCode,
            type: text,
          },
        ],
      };
    });

  const cancellationInfoConfig = [
    { key: strings.cancellationCode, value: confirmationCode },
    { key: strings.cancellationDate, value: parsedCancellationDate },
    { key: strings.approvedBy, value: approvedByName },
    { key: strings.cancellationNote, value: cancellationReason },
  ];

  const rejectionInfoConfig = [
    { key: strings.rejectedDate, value: parsedRejectedDate },
    { key: strings.rejectedBy, value: rejectedByName },
    { key: strings.rejectionNote, value: rejectionReason },
  ];

  const requestCancellationConfig = [
    { key: strings.requestStatus, value: status },
    { key: strings.requestType, value: requestType },
    { key: strings.requestCode, value: requestCode },
    { key: strings.requestReason, value: requestReason },
  ];

  const bookingInfo = [
    { key: strings.bookingDate, value: parsedDate },
    { key: nameLabels().nameLabel, value: pharmacistName },
    { key: strings.pharmacyName, value: pharmacyName },
    { key: strings.workshiftCode, value: workshiftCode },
    { key: strings.availabilityCode, value: availabilityCode },
  ];

  const table: IDynamicTableObject = {
    rows: rows(),
    headers,
    headerBar: [],
  };

  return {
    table,
    success,
    cancellationInfoConfig,
    rejectionInfoConfig,
    requestCancellationConfig,
    bookingInfo,
  };
};

export default usePendingCancellationDetails;
